import AbstractModel from '../AbstractModel';

class MaintenanceLabelModel extends AbstractModel {}

export default MaintenanceLabelModel;
